var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/audios/background-sound.mp3": "10dc",
	"./assets/audios/button-click.mp3": "0fac",
	"./assets/audios/start-activity.mp3": "fac3",
	"./assets/audios/vo/vo-01-01.mp3": "1210",
	"./assets/audios/vo/vo-01-02.mp3": "341a",
	"./assets/audios/vo/vo-01-03.mp3": "4d0a",
	"./assets/audios/vo/vo-01-04.mp3": "5b81",
	"./assets/audios/vo/vo-01-05.mp3": "6202",
	"./assets/audios/vo/vo-01-06.mp3": "f7fc",
	"./assets/audios/vo/vo-01-07.mp3": "dbf4",
	"./assets/audios/vo/vo-01-modal.mp3": "bb39",
	"./assets/audios/vo/vo-02-01.mp3": "6821",
	"./assets/audios/vo/vo-02-02.mp3": "8d65",
	"./assets/audios/vo/vo-02-03.mp3": "34d3",
	"./assets/audios/vo/vo-02-04.mp3": "7040",
	"./assets/audios/vo/vo-02-05.mp3": "b0fa",
	"./assets/audios/vo/vo-02-modal.mp3": "0a6a",
	"./assets/audios/vo/vo-03-01.mp3": "1bd2",
	"./assets/audios/vo/vo-03-02.mp3": "db83",
	"./assets/audios/vo/vo-03-03.mp3": "46a4",
	"./assets/audios/vo/vo-03-04.mp3": "118c",
	"./assets/audios/vo/vo-03-05.mp3": "4cb8",
	"./assets/audios/vo/vo-03-06.mp3": "26c7",
	"./assets/audios/vo/vo-03-07.mp3": "597c",
	"./assets/audios/vo/vo-03-08.mp3": "6179",
	"./assets/audios/vo/vo-03-modal.mp3": "aed8",
	"./assets/audios/vo/vo-04-01.mp3": "3e53",
	"./assets/audios/vo/vo-04-02.mp3": "21d0",
	"./assets/audios/vo/vo-04-03.mp3": "057c",
	"./assets/audios/vo/vo-04-04.mp3": "cb35",
	"./assets/audios/vo/vo-04-05.mp3": "3824",
	"./assets/audios/vo/vo-04-modal.mp3": "7a63",
	"./assets/audios/vo/vo-splash-screen.mp3": "8dbc",
	"./assets/images/bg-loading.gif": "2870",
	"./assets/images/bg-slide-0.jpg": "c888",
	"./assets/images/bg-slide-1.jpg": "ea17",
	"./assets/images/bg-slide-2.jpg": "88fc",
	"./assets/images/bg-slide-3.jpg": "184b",
	"./assets/images/bg-slide-4.jpg": "bea9",
	"./assets/images/card-bg.png": "7c30",
	"./assets/images/s1-modal.jpg": "2989",
	"./assets/images/s2-modal.jpg": "5412",
	"./assets/images/s3-modal.jpg": "6180",
	"./assets/images/title-screen.png": "0a4d",
	"./assets/videos/vid-slide-0.mp4": "9718",
	"./assets/videos/vid-slide-1.mp4": "8e62",
	"./assets/videos/vid-slide-2.mp4": "2675",
	"./assets/videos/vid-slide-3.mp4": "380f",
	"./assets/videos/vid-slide-4.mp4": "7514",
	"./components/game/ConnectorLabel": "070f",
	"./components/game/ConnectorLabel.vue": "070f",
	"./components/game/GameBase": "a9ff",
	"./components/game/GameBase.vue": "a9ff",
	"./components/game/SlideBase": "0962",
	"./components/game/SlideBase.vue": "0962",
	"./components/modals": "d027",
	"./components/modals/": "d027",
	"./components/modals/CardModal": "dae0",
	"./components/modals/CardModal.vue": "dae0",
	"./components/modals/LoadingModal": "3851",
	"./components/modals/LoadingModal.vue": "3851",
	"./components/modals/SlideModal": "723f",
	"./components/modals/SlideModal.vue": "723f",
	"./components/modals/index": "d027",
	"./components/modals/index.js": "d027",
	"./components/slides": "4cd6",
	"./components/slides/": "4cd6",
	"./components/slides/Slide0": "fa2f",
	"./components/slides/Slide0.vue": "fa2f",
	"./components/slides/Slide1": "0d68",
	"./components/slides/Slide1.vue": "0d68",
	"./components/slides/Slide2": "af5c",
	"./components/slides/Slide2.vue": "af5c",
	"./components/slides/Slide3": "4c9d",
	"./components/slides/Slide3.vue": "4c9d",
	"./components/slides/Slide4": "fd5d",
	"./components/slides/Slide4.vue": "fd5d",
	"./components/slides/index": "4cd6",
	"./components/slides/index.js": "4cd6",
	"./composables/useSlides": "6cb0",
	"./composables/useSlides.js": "6cb0",
	"./composables/useStore": "e70e",
	"./composables/useStore.js": "e70e",
	"./config/data-initial": "2d76",
	"./config/data-initial.js": "2d76",
	"./config/media": "d675",
	"./config/media.js": "d675",
	"./fonts/ArchitectsDaughter/ArchitectsDaughter-Regular.ttf": "cafd",
	"./fonts/Nunito/Nunito-Black.ttf": "faac",
	"./fonts/Nunito/Nunito-Bold.ttf": "2409",
	"./fonts/Nunito/Nunito-ExtraBold.ttf": "04a5",
	"./fonts/Nunito/Nunito-Light.ttf": "0db9",
	"./fonts/Nunito/Nunito-Regular.ttf": "991a",
	"./fonts/Nunito/Nunito-SemiBold.ttf": "801e",
	"./main": "56d7",
	"./main.js": "56d7",
	"./pages": "4570",
	"./pages/": "4570",
	"./pages/GamePage": "a233",
	"./pages/GamePage.vue": "a233",
	"./pages/IntroPage": "6b81",
	"./pages/IntroPage.vue": "6b81",
	"./pages/LoadingPage": "5f0d",
	"./pages/LoadingPage.vue": "5f0d",
	"./pages/index": "4570",
	"./pages/index.js": "4570",
	"./store": "4360",
	"./store/": "4360",
	"./store/game.module": "cd99",
	"./store/game.module.js": "cd99",
	"./store/index": "4360",
	"./store/index.js": "4360",
	"./styles/main.styl": "2583",
	"./styles/variables.genentech.styl": "a206",
	"./views/MainView": "427d",
	"./views/MainView.vue": "427d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";